export interface SportCategory {
  slug: string;
  name: string;
  icon: string;
  description: string;
  matchCount: number;
}

export interface LiveMatch {
  id: string;
  homeTeam: string;
  awayTeam: string;
  homeScore: number;
  awayScore: number;
  status: 'live' | 'upcoming' | 'finished';
  minute: number;
  league: string;
  category: string;
  homeLogo: string;
  awayLogo: string;
}

export interface SportArticle {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  author: string;
  publishDate: string;
  readCount: number;
  coverImage: string;
  tags: string[];
}

export interface StatItem {
  label: string;
  value: string;
  icon: string;
  change: string;
}

export const sportCategories: SportCategory[] = [
  {
    slug: 'football',
    name: '足球',
    icon: 'ri-football-line',
    description: '全球最受欢迎的体育运动，涵盖英超、西甲、欧冠等顶级联赛实时数据与深度分析。',
    matchCount: 128,
  },
  {
    slug: 'basketball',
    name: '篮球',
    icon: 'ri-basketball-line',
    description: 'NBA、CBA、欧洲篮球联赛等赛事全覆盖，实时比分、球员数据、战术分析一应俱全。',
    matchCount: 96,
  },
  {
    slug: 'tennis',
    name: '网球',
    icon: 'ri-trophy-line',
    description: '四大满贯、ATP、WTA巡回赛全程跟踪，专业数据统计与比赛预测分析。',
    matchCount: 64,
  },
  {
    slug: 'esports',
    name: '电子竞技',
    icon: 'ri-gamepad-line',
    description: 'LOL、DOTA2、CS2等顶级电竞赛事直播与数据，紧跟电竞产业发展脉搏。',
    matchCount: 52,
  },
  {
    slug: 'baseball',
    name: '棒球',
    icon: 'ri-base-station-line',
    description: 'MLB、NPB等职业棒球联赛赛事数据，专业投打数据分析与比赛走势预测。',
    matchCount: 36,
  },
  {
    slug: 'racing',
    name: '赛车',
    icon: 'ri-speed-up-line',
    description: 'F1、MotoGP、WRC等顶级赛车赛事，排位赛成绩、正赛实时数据追踪。',
    matchCount: 28,
  },
];

export const liveMatches: LiveMatch[] = [
  {
    id: 'match-1',
    homeTeam: '皇家马德里',
    awayTeam: '巴塞罗那',
    homeScore: 2,
    awayScore: 1,
    status: 'live',
    minute: 67,
    league: '西甲联赛',
    category: 'football',
    homeLogo: '',
    awayLogo: '',
  },
  {
    id: 'match-2',
    homeTeam: '洛杉矶湖人',
    awayTeam: '金州勇士',
    homeScore: 98,
    awayScore: 102,
    status: 'live',
    minute: 36,
    league: 'NBA常规赛',
    category: 'basketball',
    homeLogo: '',
    awayLogo: '',
  },
  {
    id: 'match-3',
    homeTeam: '曼城',
    awayTeam: '阿森纳',
    homeScore: 0,
    awayScore: 0,
    status: 'upcoming',
    minute: 0,
    league: '英超联赛',
    category: 'football',
    homeLogo: '',
    awayLogo: '',
  },
  {
    id: 'match-4',
    homeTeam: '德约科维奇',
    awayTeam: '阿尔卡拉斯',
    homeScore: 2,
    awayScore: 1,
    status: 'live',
    minute: 0,
    league: 'ATP大师赛',
    category: 'tennis',
    homeLogo: '',
    awayLogo: '',
  },
  {
    id: 'match-5',
    homeTeam: 'T1',
    awayTeam: 'Gen.G',
    homeScore: 2,
    awayScore: 0,
    status: 'live',
    minute: 28,
    league: 'LCK夏季赛',
    category: 'esports',
    homeLogo: '',
    awayLogo: '',
  },
  {
    id: 'match-6',
    homeTeam: '纽约洋基',
    awayTeam: '波士顿红袜',
    homeScore: 5,
    awayScore: 3,
    status: 'finished',
    minute: 0,
    league: 'MLB常规赛',
    category: 'baseball',
    homeLogo: '',
    awayLogo: '',
  },
];

export const sportArticles: SportArticle[] = [
  {
    id: 'article-1',
    title: '2026世界杯预选赛亚洲区：中国队关键战役深度分析',
    summary: '随着2026世界杯预选赛进入白热化阶段，中国队将在下一轮迎来与日本队的关键对决。本文从阵容配置、战术打法、历史交锋等多个维度进行全面解析。',
    content: `<p>随着2026年世界杯预选赛亚洲区12强赛进入白热化阶段，中国国家男子足球队即将在主场迎战日本队，这场比赛对于两队的出线形势都至关重要。</p>
<h2>赛前形势分析</h2>
<p>目前中国队在小组中积13分排名第三，落后排名第二的澳大利亚队2分。日本队则以18分高居榜首，已基本锁定一个直接出线名额。对于中国队而言，本场比赛若能在主场取分，将极大提升晋级希望。</p>
<h2>阵容配置解读</h2>
<p>中国队主教练在赛前发布会上透露，球队将以4-3-3阵型出战。武磊将继续担任锋线箭头，中场由吴曦和李可搭档双后腰，防线方面蒋光太与朱辰杰组成中卫组合。归化球员费南多将出现在右边锋位置，他的速度和突破能力将是撕裂日本队防线的重要武器。</p>
<h2>战术博弈关键点</h2>
<p>日本队以传控见长，场均控球率达到62%。中国队若想在这场比赛中有所斩获，必须在以下三个方面做好：首先是高位逼抢的时机选择，不能盲目压上给对手反击空间；其次是边路防守的协防配合，日本队的两翼进攻极为犀利；最后是定位球的攻防，这是中国队相对占优的环节。</p>
<h2>历史交锋回顾</h2>
<p>中日两队近10次交手，中国队取得2胜3平5负的成绩。上一次在主场战胜日本队还要追溯到2018年的东亚杯。不过值得注意的是，中国队在最近三次主场面对日本队的比赛中均取得进球，这说明在主场球迷的支持下，中国队的进攻端能够给日本队制造威胁。</p>
<h2>专家预测</h2>
<p>综合各方面因素，本场比赛预计将是一场激烈的对决。中国队坐拥主场之利，若能发挥出最佳水平，完全有能力在主场拿分。预计最终比分可能是1-1或2-1。</p>`,
    category: 'football',
    author: '张明远',
    publishDate: '2026-08-07',
    readCount: 12580,
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20football%20stadium%20atmosphere%20with%20Chinese%20national%20team%20fans%20waving%20flags%20in%20red%20attire%2C%20dramatic%20stadium%20lighting%20at%20night%2C%20wide%20angle%20shot%20capturing%20passionate%20crowd%20and%20green%20pitch%2C%20sports%20journalism%20photography%20style%20with%20vibrant%20energy%20and%20patriotic%20mood&width=800&height=450&seq=article-football-1&orientation=landscape',
    tags: ['世界杯', '中国队', '日本队', '预选赛', '战术分析'],
  },
  {
    id: 'article-2',
    title: 'NBA新赛季前瞻：勇士王朝能否再度崛起？',
    summary: '经历了一个令人失望的赛季后，金州勇士在休赛期进行了大刀阔斧的阵容调整。库里、追梦格林的核心框架依然稳固，新援的加入能否让勇士重返争冠行列？',
    content: `<p>金州勇士在2025-2026赛季的表现令球迷大失所望，他们在季后赛首轮便遭到淘汰。休赛期管理层痛定思痛，对阵容进行了多项关键调整。</p>
<h2>休赛期操作回顾</h2>
<p>勇士在自由市场上动作频频，签下了全明星级别的前锋，同时通过选秀获得了潜力新秀。球队的薪资结构也进行了优化，为未来的操作留出了灵活性。</p>
<h2>核心阵容评估</h2>
<p>斯蒂芬·库里依然是这支球队的灵魂。上赛季他场均贡献28.6分、6.2次助攻，三分命中率保持在42%的精英水准。德雷蒙德·格林的防守组织和进攻串联作用同样不可替代。</p>
<h2>西部格局分析</h2>
<p>西部联盟的竞争格局在过去一年发生了显著变化。掘金、雷霆、森林狼等年轻球队持续崛起，湖人和快船依然保持着竞争力。勇士想要重返西部决赛甚至总决赛，面临的挑战空前严峻。</p>
<h2>新赛季展望</h2>
<p>综合来看，勇士的核心竞争力依然存在，库里的巅峰状态至少还能保持2-3年。如果新援能够快速融入体系，年轻球员能够持续进步，勇士完全有能力在2026-2027赛季重返争冠行列。</p>`,
    category: 'basketball',
    author: '李浩然',
    publishDate: '2026-08-06',
    readCount: 9870,
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20arena%20with%20Golden%20State%20Warriors%20team%20in%20action%20on%20court%2C%20warm%20golden%20and%20blue%20stadium%20lighting%2C%20dramatic%20sports%20photography%20capturing%20fast%20pace%20basketball%20action%20with%20motion%20blur%2C%20NBA%20game%20atmosphere%20with%20cheering%20crowd&width=800&height=450&seq=article-basketball-1&orientation=landscape',
    tags: ['NBA', '勇士', '库里', '赛季前瞻', '篮球'],
  },
  {
    id: 'article-3',
    title: 'ATP年终排名争夺战：新生代球员强势崛起',
    summary: '2026赛季ATP巡回赛进入后半程，年终世界第一的争夺愈发激烈。阿尔卡拉斯、辛纳等新生代选手的崛起正在重塑男子网坛格局。',
    content: `<p>2026年ATP巡回赛赛程过半，男单世界排名的争夺进入了白热化阶段。以卡洛斯·阿尔卡拉斯和扬尼克·辛纳为代表的新生代力量正在强势崛起，传统三巨头的时代正在悄然落幕。</p>
<h2>阿尔卡拉斯的统治力</h2>
<p>西班牙天才少年在本赛季已经斩获了包括法网在内的三个大师赛冠军。他的全能型打法——兼具力量、速度和战术智慧——让他在红土、硬地和草地三种场地上都具备了极强的竞争力。</p>
<h2>辛纳的稳定输出</h2>
<p>意大利选手扬尼克·辛纳在本赛季展现出了令人惊叹的稳定性。他在所有参加的大满贯赛事中至少闯入八强，并在澳网成功卫冕。他标志性的底线进攻和日益成熟的网前技术使他成为了任何对手都不敢轻视的存在。</p>
<h2>老将的坚守</h2>
<p>诺瓦克·德约科维奇虽然已经39岁高龄，但他的竞技状态依然令人敬畏。塞尔维亚天王在本赛季初的澳网闯入决赛，并在红土赛季展现了极强的统治力。</p>
<h2>年终第一预测</h2>
<p>目前阿尔卡拉斯在冠军积分榜上以微弱优势领先辛纳。考虑到下半赛季还有美网和年终总决赛两个大分赛事，年终世界第一的归属仍有很大悬念。</p>`,
    category: 'tennis',
    author: '王子轩',
    publishDate: '2026-08-05',
    readCount: 7650,
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20player%20serving%20on%20clay%20court%20under%20bright%20sunlight%2C%20dynamic%20sports%20action%20photography%20with%20clean%20orange%20clay%20surface%20and%20stadium%20background%2C%20athletic%20form%20captured%20at%20peak%20moment%20with%20racket%20and%20ball%2C%20Roland%20Garros%20style%20atmosphere&width=800&height=450&seq=article-tennis-1&orientation=landscape',
    tags: ['网球', 'ATP', '阿尔卡拉斯', '辛纳', '年终排名'],
  },
  {
    id: 'article-4',
    title: '英雄联盟S16全球总决赛：LPL赛区四强队伍深度解析',
    summary: '英雄联盟S16全球总决赛即将拉开帷幕，LPL赛区的四支代表队实力强劲。本文从战队风格、核心选手、BP策略等方面进行全面解读。',
    content: `<p>英雄联盟2026赛季全球总决赛（S16）即将在韩国首尔拉开帷幕。作为卫冕赛区，LPL派出了四支实力强劲的代表队参赛。</p>
<h2>一号种子：统治力依旧</h2>
<p>作为LPL夏季赛冠军，BLG战队以全华班的阵容展现了极强的统治力。上单Bin的战士英雄池深厚，中单Knight的法师和刺客都是世界顶级水准，下路Elk和ON的组合在LPL赛区几乎没有对手。</p>
<h2>二号种子：老牌劲旅回归</h2>
<p>JDG在本赛季重整旗鼓，重新回到了LPL顶级战队的行列。Kanavi在野区的节奏控制能力是JDG最核心的武器。</p>
<h2>三号和四号种子：黑马之姿</h2>
<p>TES和WBG分别以三号和四号种子的身份晋级世界赛。TES的双C组合JackeyLove和Creme状态火热，WBG则依靠Xiaohu的经验和TheShy的个人能力在冒泡赛中脱颖而出。</p>
<h2>国际赛对手分析</h2>
<p>LCK赛区的GEN和T1依然是LPL最强劲的对手。GEN的中野组合Chovy和Canyon被誉为世界最强，而T1的老将Faker依然是大赛中最值得警惕的选手。</p>
<h2>S16冠军预测</h2>
<p>综合赛区整体实力和近期状态，LPL赛区依然是本届世界赛的夺冠热门。BLG和JDG都具备夺冠实力，但GEN在主场作战的优势也不容小觑。</p>`,
    category: 'esports',
    author: '陈天宇',
    publishDate: '2026-08-04',
    readCount: 15200,
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20esports%20arena%20with%20massive%20LED%20screens%20displaying%20League%20of%20Legends%20gameplay%2C%20packed%20stadium%20with%20thousands%20of%20fans%20cheering%2C%20dramatic%20blue%20and%20red%20stage%20lighting%2C%20professional%20gaming%20championship%20atmosphere%20with%20players%20on%20stage%2C%20grand%20scale%20event&width=800&height=450&seq=article-esports-1&orientation=landscape',
    tags: ['英雄联盟', 'S16', 'LPL', '电竞', '全球总决赛'],
  },
  {
    id: 'article-5',
    title: 'MLB赛季中期交易市场：哪些球员将成为关键拼图？',
    summary: 'MLB交易截止日临近，多支有望冲击季后赛的球队正在积极寻求阵容补强。本文分析当前交易市场上最受关注的几位球员及其潜在下家。',
    content: `<p>随着MLB赛季进入下半程，各支有望冲击季后赛的球队正在紧锣密鼓地评估交易市场上的可用资源。</p>
<h2>交易市场概况</h2>
<p>本赛季交易市场呈现卖方强势的态势。由于多支球队仍在季后赛争夺范围内，愿意出售核心球员的卖家相对较少，这使得优质球员的交易价值被推高。</p>
<h2>热门交易目标</h2>
<p>几位全明星级别的先发投手成为交易市场上最炙手可热的目标。此外，具备打击能力的捕手和多功能内野手也备受追捧。</p>
<h2>买家球队分析</h2>
<p>道奇队、勇士队和太空人队被认为是交易市场上最积极的买家。道奇队需要补强先发轮值的深度，勇士队则在寻找一名有影响力的外野手。</p>
<h2>交易截止日预测</h2>
<p>预计在交易截止日前夕，将会有多笔重磅交易发生。其中涉及全明星级别球员的交易最有可能在最后48小时内完成。</p>`,
    category: 'baseball',
    author: '赵志远',
    publishDate: '2026-08-03',
    readCount: 4320,
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20baseball%20stadium%20with%20pitcher%20in%20full%20windup%20motion%20on%20mound%2C%20golden%20hour%20sunlight%20illuminating%20green%20field%20and%20diamond%2C%20MLB%20game%20atmosphere%20with%20vintage%20baseball%20aesthetic%2C%20dramatic%20sports%20photography%20with%20warm%20tones&width=800&height=450&seq=article-baseball-1&orientation=landscape',
    tags: ['MLB', '棒球', '交易市场', '季后赛', '球员分析'],
  },
  {
    id: 'article-6',
    title: 'F1 2026赛季技术规则大改：各车队如何应对新挑战？',
    summary: 'F1 2026赛季迎来了近年来最大规模的技术规则变更。新规之下，各支车队的竞争力格局可能发生剧烈变化。',
    content: `<p>F1 2026赛季的技术规则改革被业内人士称为"近年来最激进的一次变革"。新规涉及动力单元、空气动力学和底盘设计等多个核心领域，预计将彻底重塑F1的竞争格局。</p>
<h2>动力单元革新</h2>
<p>新规要求动力单元的电能输出占比提升至50%，并取消了MGU-H装置。这意味着各支车队需要重新设计动力单元架构，对燃油效率和能量回收系统提出了更高要求。</p>
<h2>空气动力学变化</h2>
<p>新规引入了主动空气动力学系统，允许车手在直道上降低下压力以提高极速，在弯道中增加下压力以提高过弯速度。</p>
<h2>车队备战情况</h2>
<p>红牛车队被认为在新技术规则下仍将保持优势，但法拉利和梅赛德斯都在新规研发上投入了巨大资源。</p>
<h2>赛季展望</h2>
<p>新规生效的首个赛季往往伴随着格局洗牌。预计2026赛季将出现多支车队争夺冠军的局面，比赛的不可预测性将大幅提升。</p>`,
    category: 'racing',
    author: '刘子豪',
    publishDate: '2026-08-02',
    readCount: 5680,
    coverImage: 'https://readdy.ai/api/search-image?query=Formula%201%20race%20car%20speeding%20on%20track%20with%20motion%20blur%20effect%2C%20rainy%20conditions%20with%20water%20spray%20behind%20tires%2C%20dynamic%20motorsport%20photography%20capturing%20speed%20and%20precision%2C%20professional%20racing%20atmosphere%20with%20wet%20asphalt%20reflecting%20lights&width=800&height=450&seq=article-racing-1&orientation=landscape',
    tags: ['F1', '赛车', '技术规则', '2026赛季', '车队分析'],
  },
];

export const statsData: StatItem[] = [
  { label: '覆盖赛事', value: '500+', icon: 'ri-global-line', change: '+12%' },
  { label: '每日直播', value: '200+', icon: 'ri-live-line', change: '+25%' },
  { label: '活跃用户', value: '380万', icon: 'ri-user-star-line', change: '+18%' },
  { label: '数据维度', value: '150+', icon: 'ri-bar-chart-2-line', change: '+30%' },
];

export const featuredContent = {
  heroTitle: '开体育在线',
  heroSubtitle: '您的首选体育赛事在线服务平台',
  heroDescription: '覆盖足球、篮球、网球、电竞等多项赛事，提供实时直播、深度数据分析与专业赛事预测，随时随地享受全方位体育在线体验。',
};